module.exports = __webpack_public_path__ + "assets/img/ic-internet-bank.aa05815e.svg";